import React from 'react'
import SbEditable from 'storyblok-react'

const BigTextBlock = ({ block }) => {
  return (
    <SbEditable content={block}>
      <section
        className={`big-text-block ${block.space_top ? block.space_top : ''} ${
          block.space_bottom ? block.space_bottom : ''
        }`}
      >
        <div className="big-text-block-body">
          <p>{block.text}</p>
        </div>
      </section>
    </SbEditable>
  )
}

export default BigTextBlock
